import { FaInstagram } from "react-icons/fa";
import { FaShoppingBag } from "react-icons/fa";
import { BsFillCake2Fill } from "react-icons/bs";
import { BsCalendar2DayFill } from "react-icons/bs";
import { Tabs } from "./Tabs";

export function Profile({ profile, posts, projects, skills }) {
    return (
        <div className="profile col-lg-7 px-2 px-sm-0 m-auto">
            <div className="profile-header d-flex justify-content-between">
                <div className="profile-header__image">
                    <img className="profile-header__img rounded-circle" src={profile.imageProfile} alt="Foto de perfil Fernando" />
                </div>
                <div className="profile-header__box d-flex align-items-end mb-lg-2">
                    <a className='profile-header__btn px-4 rounded-pill d-flex justify-content-center align-items-center' href={profile.linkInstagram} target="_blank" rel="noopener noreferrer">
                        Seguir
                        <FaInstagram className="ms-2" />
                    </a>
                </div>
            </div>

            <div className="profile-body text-start">
                <h1 className="profile-body__name mt-3 mt-lg-1">
                    {profile.name} {profile.lastname}
                    {/* <span className="profile-body__name-icon ms-2">
                        <svg viewBox="0 0 750 750" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="375" cy="375" r="310" fill="white"></circle>
                            <path fillRule="evenodd" clipRule="evenodd" d="M494.195 662.762C541.279 687.206 600.656 679.674 640.165 640.165C679.674 600.656 687.206 541.279 662.762 494.195C713.34 478.186 750 430.874 750 375C750 319.126 713.34 271.814 662.762 255.805C687.206 208.721 679.674 149.344 640.165 109.835C600.656 70.326 541.279 62.7937 494.195 87.2381C478.186 36.6595 430.874 0 375 0C319.126 0 271.814 36.6596 255.805 87.2381C208.721 62.7937 149.344 70.326 109.835 109.835C70.326 149.344 62.7937 208.721 87.2381 255.805C36.6596 271.814 0 319.126 0 375C0 430.874 36.6596 478.186 87.2381 494.195C62.7937 541.279 70.326 600.656 109.835 640.165C149.344 679.674 208.721 687.206 255.805 662.762C271.814 713.34 319.126 750 375 750C430.874 750 478.186 713.34 494.195 662.762ZM116 289.841C116 325.908 139.763 356.389 172.52 366.829C170.618 376.272 169.644 385.705 169.644 394.907H301.477V388.362H448.32V394.907H580.806C580.806 385.249 579.733 375.337 577.64 365.425C610.238 355.565 634 325.488 634 289.841C634 246.157 598.316 210.838 554.414 210.838C525.12 210.838 499.484 226.563 485.668 250.006C452.922 233.407 414.658 224.39 375.225 224.39C336.88 224.39 299.64 232.916 267.505 248.65C253.308 224.896 227.211 209 197.425 209C152.521 209 116 245.129 116 289.841ZM197.425 227.379C162.545 227.379 134.388 255.409 134.388 289.841C134.388 317.289 152.281 340.669 177.21 349.024C186.635 320.107 204.629 292.396 229.857 272.315C236.613 266.938 243.79 261.974 251.328 257.443C240.282 239.433 220.299 227.379 197.425 227.379ZM446.779 360.115H303.018C306.737 349.679 316.77 342.202 328.564 342.202H421.233C433.027 342.202 443.061 349.679 446.779 360.115ZM619.29 289.841C619.29 318.579 600.247 342.969 573.927 351.183C564.705 321.49 546.448 292.895 520.593 272.315C513.67 266.805 506.305 261.729 498.563 257.108C509.854 238.223 530.619 225.541 554.414 225.541C590.296 225.541 619.29 254.381 619.29 289.841ZM509.964 436.589C509.964 446.102 502.19 453.813 492.6 453.813C483.011 453.813 475.237 446.102 475.237 436.589C475.237 427.077 483.011 419.365 492.6 419.365C502.19 419.365 509.964 427.077 509.964 436.589ZM276.601 436.589C276.601 446.102 268.828 453.813 259.238 453.813C249.649 453.813 241.875 446.102 241.875 436.589C241.875 427.077 249.649 419.365 259.238 419.365C268.828 419.365 276.601 427.077 276.601 436.589ZM375.572 542C399.162 542 420.369 522.299 420.369 504.796C420.369 487.293 399.162 478.616 375.572 478.616C351.982 478.616 330.775 487.293 330.775 504.796C330.775 522.299 351.982 542 375.572 542Z" fill="hsl(320 100% 40%)"></path>
                        </svg>
                    </span> */}
                </h1>
                <p className="profile-body__phrase">{`"${profile.phrase}" - ${profile.phraseAuthor}.`}</p>
                <p className="profile-body__text">{profile.profileText}</p>
            </div>

            <div className="profile-icons d-flex flex-column flex-sm-row">
                <ProfileIcons
                    text={profile.workStatus}
                    icon={<FaShoppingBag className="mt-lg-1 me-1" />} />
                <ProfileIcons
                    text={profile.birthday}
                    icon={<BsFillCake2Fill className="mt-lg-1 me-1" />} />
                <ProfileIcons
                    text={profile.startDate}
                    icon={<BsCalendar2DayFill className="mt-lg-1 me-1" />} />
            </div>

            <div className="profile-tabs mt-5">
                <Tabs
                    profile={profile}
                    posts={posts}
                    projects={projects}
                    skills={skills} />
            </div>
        </div>
    );
}

export function ProfileIcons({ text, icon }) {
    return (
        <div className="profile-icons mt-1 mt-lg-0 me-3 d-flex">
            <div className="profile-icons__section d-flex alig-items-center">
                {icon}
                <p className="profile-icons__text mb-0">{text}</p>
            </div>
        </div>
    );
}